import { IApplicationState } from '../../types/redux';

export const selectManagementCompany = (state: IApplicationState) => state.managementCompany.data;
